import { useState } from 'react';
import { testimonials } from '../../../mocks/homeData';

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const featured = testimonials[active];

  return (
    <section className="bg-[#0C0C0C] py-28" id="reviews">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Client Reviews
            </span>
            <h2 className="font-display font-black text-5xl lg:text-6xl text-white leading-tight">
              What Our Clients
              <br />
              <span className="text-[#FF6B35]">Are Saying</span>
            </h2>
          </div>
          <div className="flex flex-col items-start lg:items-end gap-1.5">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="w-5 h-5 flex items-center justify-center"><i className="ri-star-fill text-[#FF6B35] text-lg" /></span>
              ))}
            </div>
            <p className="text-white font-bold text-lg">5.0 / 5.0</p>
            <p className="text-gray-500 text-sm">100+ verified Google reviews</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5 mb-10">
          {/* Featured */}
          <div className="lg:col-span-3 bg-[#111111] border border-white/10 rounded-2xl p-10 flex flex-col justify-between relative overflow-hidden">
            <div className="absolute top-6 right-6 text-white/3 leading-none">
              <i className="ri-double-quotes-l" style={{ fontSize: '110px' }} />
            </div>
            <div className="relative z-10">
              <div className="flex items-center gap-1.5 mb-6">
                {[...Array(featured.rating)].map((_, i) => (
                  <span key={i} className="w-5 h-5 flex items-center justify-center"><i className="ri-star-fill text-[#FF6B35] text-lg" /></span>
                ))}
              </div>
              <p className="text-white text-xl leading-relaxed font-light italic mb-8 max-w-xl">&ldquo;{featured.text}&rdquo;</p>
            </div>
            <div className="relative z-10 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <img src={featured.image} alt={featured.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#FF6B35]" />
                <div>
                  <strong className="text-white font-bold block">{featured.name}</strong>
                  <span className="text-gray-500 text-sm">{featured.location}</span>
                </div>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/15 rounded-full">
                <i className="ri-google-fill text-[#FF6B35] text-lg" />
              </div>
            </div>
          </div>

          {/* Side stack */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {testimonials.filter((_, i) => i !== active).slice(0, 3).map((t) => (
              <div key={t.id} className="bg-[#111111] border border-white/8 rounded-xl p-5 hover:border-[#FF6B35]/30 transition-colors cursor-pointer group"
                onClick={() => setActive(testimonials.findIndex(x => x.id === t.id))}>
                <div className="flex items-center gap-1 mb-2.5">
                  {[...Array(t.rating)].map((_, i) => (
                    <span key={i} className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-star-fill text-[#FF6B35] text-xs" /></span>
                  ))}
                </div>
                <p className="text-gray-400 text-xs italic leading-relaxed mb-3">
                  &ldquo;{t.text.length > 100 ? `${t.text.slice(0, 100)}...` : t.text}&rdquo;
                </p>
                <div className="flex items-center gap-2.5">
                  <img src={t.image} alt={t.name} className="w-8 h-8 rounded-full object-cover" />
                  <div>
                    <strong className="text-white text-xs font-bold block">{t.name}</strong>
                    <span className="text-gray-600 text-xs">{t.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation + CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            {testimonials.map((_, i) => (
              <button key={i} onClick={() => setActive(i)}
                className={`rounded-full transition-all cursor-pointer ${i === active ? 'w-8 h-3 bg-[#FF6B35]' : 'w-3 h-3 bg-white/20 hover:bg-white/40'}`} />
            ))}
          </div>
          <a href="#lead-form"
            className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-7 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
            Book Your Protection Package
          </a>
        </div>
      </div>
    </section>
  );
}
